import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-490d141c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "credit-section",
  class: "d-flex credit flex-column w-100 justify-content-center align-items-center align-items-sm-end mt-5"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" Photos from "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "p-0 ms-1",
    target: "_blank",
    href: "https://unsplash.com/"
  }, " unsplash")
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}